module.exports = __webpack_public_path__ + "img/play.6c9333f7.svg";